module.exports = __webpack_public_path__ + "static/media/229-turkmenistan.9cd17faa.svg";